// @flow

// Generated by ChatGPT from the possible locales supported by fonts according to Asset API.
export const languageNames = {
  af: { languageName: 'Afrikaans', languageNativeName: 'Afrikaans' },
  am: { languageName: 'Amharic', languageNativeName: 'አማርኛ' },
  ar: { languageName: 'Arabic', languageNativeName: 'العربية' },
  az: { languageName: 'Azerbaijani', languageNativeName: 'Azərbaycan dili' },
  be: { languageName: 'Belarusian', languageNativeName: 'беларуская' },
  bg: { languageName: 'Bulgarian', languageNativeName: 'български' },
  bn: { languageName: 'Bengali', languageNativeName: 'বাংলা' },
  bs: { languageName: 'Bosnian', languageNativeName: 'bosanski' },
  ca: { languageName: 'Catalan', languageNativeName: 'català' },
  cs: { languageName: 'Czech', languageNativeName: 'čeština' },
  cy: { languageName: 'Welsh', languageNativeName: 'Cymraeg' },
  da: { languageName: 'Danish', languageNativeName: 'dansk' },
  de: { languageName: 'German', languageNativeName: 'Deutsch' },
  el: { languageName: 'Greek', languageNativeName: 'Ελληνικά' },
  en: { languageName: 'English', languageNativeName: 'English' },
  es: { languageName: 'Spanish', languageNativeName: 'español' },
  et: { languageName: 'Estonian', languageNativeName: 'eesti keel' },
  eu: { languageName: 'Basque', languageNativeName: 'euskara' },
  fa: { languageName: 'Persian', languageNativeName: 'فارسی' },
  fi: { languageName: 'Finnish', languageNativeName: 'suomi' },
  fil: { languageName: 'Filipino', languageNativeName: 'Filipino' },
  fo: { languageName: 'Faroese', languageNativeName: 'føroyskt' },
  fr: { languageName: 'French', languageNativeName: 'français' },
  ga: { languageName: 'Irish', languageNativeName: 'Gaeilge' },
  gl: { languageName: 'Galician', languageNativeName: 'galego' },
  gu: { languageName: 'Gujarati', languageNativeName: 'ગુજરાતી' },
  he: { languageName: 'Hebrew', languageNativeName: 'עברית' },
  hi: { languageName: 'Hindi', languageNativeName: 'हिन्दी' },
  hr: { languageName: 'Croatian', languageNativeName: 'hrvatski' },
  hu: { languageName: 'Hungarian', languageNativeName: 'magyar' },
  hy: { languageName: 'Armenian', languageNativeName: 'հայերեն' },
  id: { languageName: 'Indonesian', languageNativeName: 'Bahasa Indonesia' },
  is: { languageName: 'Icelandic', languageNativeName: 'íslenska' },
  it: { languageName: 'Italian', languageNativeName: 'italiano' },
  ja: { languageName: 'Japanese', languageNativeName: '日本語' },
  ka: { languageName: 'Georgian', languageNativeName: 'ქართული' },
  kk: { languageName: 'Kazakh', languageNativeName: 'қазақ тілі' },
  km: { languageName: 'Khmer', languageNativeName: 'ខ្មែរ' },
  kn: { languageName: 'Kannada', languageNativeName: 'ಕನ್ನಡ' },
  ko: { languageName: 'Korean', languageNativeName: '한국어' },
  ky: { languageName: 'Kyrgyz', languageNativeName: 'кыргызча' },
  lo: { languageName: 'Lao', languageNativeName: 'ລາວ' },
  lt: { languageName: 'Lithuanian', languageNativeName: 'lietuvių' },
  lv: { languageName: 'Latvian', languageNativeName: 'latviešu' },
  mk: { languageName: 'Macedonian', languageNativeName: 'македонски' },
  ml: { languageName: 'Malayalam', languageNativeName: 'മലയാളം' },
  mn: { languageName: 'Mongolian', languageNativeName: 'Монгол' },
  mr: { languageName: 'Marathi', languageNativeName: 'मराठी' },
  ms: { languageName: 'Malay', languageNativeName: 'Bahasa Melayu' },
  my: { languageName: 'Burmese', languageNativeName: 'မြန်မာ' },
  nb: { languageName: 'Norwegian Bokmål', languageNativeName: 'Norsk Bokmål' },
  ne: { languageName: 'Nepali', languageNativeName: 'नेपाली' },
  nl: { languageName: 'Dutch', languageNativeName: 'Nederlands' },
  pa: { languageName: 'Punjabi', languageNativeName: 'ਪੰਜਾਬੀ' },
  pl: { languageName: 'Polish', languageNativeName: 'polski' },
  pt: { languageName: 'Portuguese', languageNativeName: 'português' },
  ro: { languageName: 'Romanian', languageNativeName: 'română' },
  ru: { languageName: 'Russian', languageNativeName: 'русский' },
  si: { languageName: 'Sinhala', languageNativeName: 'සිංහල' },
  sk: { languageName: 'Slovak', languageNativeName: 'slovenčina' },
  sl: { languageName: 'Slovenian', languageNativeName: 'slovenščina' },
  sq: { languageName: 'Albanian', languageNativeName: 'shqip' },
  sr: { languageName: 'Serbian', languageNativeName: 'српски' },
  sv: { languageName: 'Swedish', languageNativeName: 'svenska' },
  sw: { languageName: 'Swahili', languageNativeName: 'Kiswahili' },
  ta: { languageName: 'Tamil', languageNativeName: 'தமிழ்' },
  te: { languageName: 'Telugu', languageNativeName: 'తెలుగు' },
  th: { languageName: 'Thai', languageNativeName: 'ไทย' },
  to: { languageName: 'Tongan', languageNativeName: 'lea fakatonga' },
  tr: { languageName: 'Turkish', languageNativeName: 'Türkçe' },
  uk: { languageName: 'Ukrainian', languageNativeName: 'українська' },
  ur: { languageName: 'Urdu', languageNativeName: 'اردو' },
  uz: { languageName: 'Uzbek', languageNativeName: 'oʻzbekcha' },
  vi: { languageName: 'Vietnamese', languageNativeName: 'Tiếng Việt' },
  yue: { languageName: 'Cantonese', languageNativeName: '粵語' },
  zh: { languageName: 'Chinese', languageNativeName: '中文' },
  zu: { languageName: 'Zulu', languageNativeName: 'isiZulu' },
};
